import React from 'react'
import MarkdownWrapper from '../../utils/markdown-wrapper'

const TextWithQuote = ({ content }) => {
    const renderOptionalHeader = () => {
        if (content?.title) {
            return (
                <div className="container">
                    <div className="title-wrapper">
                        <div className="title-stroke">
                            <h2>{content.title}</h2>
                        </div>
                    </div>
                </div>
            )
        }
        return null
    }

    if (!content) {
        return null
    }

    return (
        <div className="container">
            { renderOptionalHeader() }
            <div className={`content-band text-with-quote ${content.alignment}`}>
                <div className="text-container">
                    <MarkdownWrapper content={content.textBlock} />
                </div>
                <div className="quote-container">
                    <MarkdownWrapper content={content.quote} />
                </div>
            </div>
        </div>
    )
}

export default TextWithQuote
